import { Controller } from "@hotwired/stimulus"

// Tenant-list multi-select for "Message these tenants". Per-row checkboxes live
// in their own tap column so the row link still navigates normally. The moment
// one box is checked, a sticky action bar appears with a live count and a
// "Message N" button whose href carries the selected renter ids to the composer.
// With nothing checked, the header "Message tenants" button composes to the
// current filter/search ("message these results"); the controller leaves that
// link alone unless a selection exists.
export default class extends Controller {
  static targets = ["checkbox", "selectAll", "bar", "count", "messageLink"]
  static values = { newPath: String }

  connect() {
    this.refresh()
  }

  toggleAll() {
    const on = this.selectAllTarget.checked
    this.checkboxTargets.forEach((cb) => { cb.checked = on })
    this.refresh()
  }

  clear() {
    this.checkboxTargets.forEach((cb) => { cb.checked = false })
    if (this.hasSelectAllTarget) this.selectAllTarget.checked = false
    this.refresh()
  }

  refresh() {
    const selected = this.selectedIds()
    const n = selected.length

    if (this.hasBarTarget) this.barTarget.classList.toggle("hidden", n === 0)
    if (this.hasCountTarget) {
      this.countTarget.textContent = `${n} selected`
    }
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = n > 0 && n === this.checkboxTargets.length
      this.selectAllTarget.indeterminate = n > 0 && n < this.checkboxTargets.length
    }
    if (this.hasMessageLinkTarget && n > 0) {
      const params = selected.map((id) => `renter_ids[]=${encodeURIComponent(id)}`).join("&")
      this.messageLinkTarget.href = `${this.newPathValue}?${params}`
      this.messageLinkTarget.textContent = `Message ${n}`
    }
  }

  selectedIds() {
    return this.checkboxTargets.filter((cb) => cb.checked).map((cb) => cb.value)
  }
}
